export enum DirectionEnum{
    SRC_TO_DEST = "SRC_TO_DEST",
    BIDIRECTIONAL = "BIDIRECTIONAL",
}